/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import redirect from 'js/lib/coursera.redirect';

import { Button } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';

type Props = {
  url: string;
  title: string;
  buttonClass?: string;
};

// Redirects users to the CDP AFTER the signup modal has been displayed
const handleBrowseClick = (url: string) => {
  redirect.setLocation(url);
};

const ExploreButton: React.FC<Props> = ({ url, title, buttonClass }) => {
  const buttonClassNames = classNames(buttonClass);

  return (
    <div data-unit="vlp-eb-container" className="vlp-eb-container">
      <Button
        component={TrackedButton}
        trackingName="vlp_explore_catalog_button"
        className={buttonClassNames}
        withVisibilityTracking={false}
        requireFullyVisible={false}
        aria-label={title}
        onClick={() => handleBrowseClick(url)}
      >
        {title}
      </Button>
    </div>
  );
};
export default ExploreButton;
